var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"bc-profile-sidebar__availability"},[_c('span',{class:_setup.availabilityColorClass}),_c('span',{staticClass:"availability-label"},[_vm._v(" "+_vm._s(_vm.$t('availability.title'))+": ")]),_c('span',{staticClass:"availability-status-text",domProps:{"innerHTML":_vm._s(_setup.availabilityText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }